export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Статус"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сайт"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID Магазина"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки магазина"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Платежная ссылка"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активен"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Не активен"])}
}